import {
  CustomSelect,
  TextAppearance,
  TextCustom,
} from '@vw-marketing/us-components';
import React, { useEffect, useRef } from 'react';
import { StyledErrorMessage } from './styles';
import { Option } from './types';

interface SelectInputProps {
  label: string;
  value: string;
  options: Option[];
  appearance?: 'error' | 'success' | 'default';
  message?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  inputId?: string;
}

export const SelectInput = ({
  label,
  value,
  options,
  appearance,
  message,
  disabled,
  onChange,
  onBlur,
  onFocus,
  inputId,
}: SelectInputProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  // Set id on select and htmlFor on label for accessibility
  useEffect(() => {
    if (containerRef.current && inputId) {
      const selectElement = containerRef.current.querySelector('select');
      if (selectElement) {
        selectElement.id = inputId;
        const labelElement = selectElement.closest('label');
        if (labelElement) {
          labelElement.setAttribute('for', inputId);
        }
      }
    }
  }, [inputId]);

  return (
    <div ref={containerRef}>
      <CustomSelect
        label={label}
        value={value}
        aria-label={label}
        onChange={(event) => onChange(event.currentTarget.value)}
        onBlur={onBlur}
        onFocus={onFocus}
        appearance={appearance}
        required
        isFloating
        disabled={disabled}
      >
        <option value='' disabled>
          {label}
        </option>
        {options.map((option, index) => (
          <option value={option.value} key={`${option.value}-${index}`}>
            {option.label}
          </option>
        ))}
      </CustomSelect>
      {message && (
        <StyledErrorMessage>
          <TextCustom appearance={TextAppearance.copy100}>{message}</TextCustom>
        </StyledErrorMessage>
      )}
    </div>
  );
};
